import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { StartComponent } from './start/start.component';
import {
  BeheerSettingsComponent,
  AppSettingDialogComponent
} from './beheer-settings/beheer-settings.component';
import { BeheerTakenComponent } from './beheer-taken/beheer-taken.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { IncidentenComponent } from './incidenten/incidenten.component';
import { LogoutComponent } from './logout/logout.component';
import { AppConfigService } from './services/app-config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/token.interceptor';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { SharedModule } from './shared.module';
import { BeheerRegelsComponent } from './beheer-regels/beheer-regels.component';
import { RegelComponent } from './beheer-regels/regel.component';
import { RegelSetActieComponent } from './beheer-regels/regel-set-actie.component';
import { RegelSetDialogComponent } from './beheer-regels/dialogs/regel-set-dialog.component';
import { RegelDialogComponent } from './beheer-regels/dialogs/regel-dialog.component';
import { RegelSetActieDialogComponent } from './beheer-regels/dialogs/regel-set-actie-dialog.component';
import { RegelSetDetailsComponent } from './beheer-regels/regel-set-details.component';
import { RegelWaardeDisplayPipe } from './pipes/regel-waarde-display.pipe';
import { IncidenRegelSetStatusStatusPipe } from './pipes/inciden-regel-set-status-status.pipe';
import { IncidentRegelSetStatusComponent } from './beheer-regels/incident-regel-set-status.component';

export function init_app(appConfig: AppConfigService) {
  return () => appConfig.loadAppConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    BeheerSettingsComponent,
    BeheerTakenComponent,
    UnauthorizedComponent,
    IncidentenComponent,
    LogoutComponent,
    AppSettingDialogComponent,
    BeheerRegelsComponent,
    RegelComponent,
    RegelSetActieComponent,
    RegelSetDialogComponent,
    RegelDialogComponent,
    RegelSetActieDialogComponent,
    RegelSetDetailsComponent,
    RegelWaardeDisplayPipe,
    IncidenRegelSetStatusStatusPipe,
    IncidentRegelSetStatusComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      multi: true,
      deps: [AppConfigService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    AuthGuardService,
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
